import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'app/shared/services/api.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {

  @ViewChild('vform') validationForm: FormGroup;

  attendenceForm:FormGroup;

  selected_emp=null;
  emp_list=[]
  attendenceFormSubmitted:boolean=false;
  model={
      user: '',
      startTime: '10:00',
      endTime: '19:00',
      workingHours:'',
      attendanceDate: new Date(),
      notes: '',
      isVerified: '',
      task: '',
      status: '',
      admin_notes: '',
  }
  verified_list =[
    {name:'True',_id:true},
    {name:'False',_id:false},
  ]
  selected_verified=null
  startTime= new FormControl()
  endTime= new FormControl()
  s_time:any
  e_time:any
  timeDiff:any
  employee_badge_cat_id = '64b124832d735e2b98be9fd7'
  status_list=[]
  selected_status = null
  attendence_id:any
  user_role:any
  constructor(private formBuilder: FormBuilder,
              public toastr: ToastrService,
              public apiService:ApiService,
              private route:Router, private activatedroute : ActivatedRoute) { 
                this.user_role=JSON.parse(localStorage.getItem('user'))
                this.activatedroute.paramMap.subscribe(params => { 
                  this.attendence_id = params.get('id'); 
              }); 
              }

  ngOnInit() {
   
    this.getAllEmpList()
    this.getStatusList()

    this.attendenceForm=this.formBuilder.group({
      attendanceDate: ['', Validators.required],
      notes: ['', ],
      admin_notes: ['', ],
      task: ['', ]
    })
    this.startTime.valueChanges.subscribe((value) => {
      const date = new Date().toDateString();
      this.s_time = new Date(date+" "+value)
      
    })
    this.endTime.valueChanges.subscribe((value) => {
      const date = new Date().toDateString();
      this.e_time = new Date(date+" "+value)
      this.getDiff(this.s_time,this.e_time)
    })
    if(this.attendence_id){
      this.getAttendenceById(this.attendence_id)
    }
  }
 
  getDiff(stime,etime){
     const diffInMilliseconds = etime.getTime() - stime.getTime();
      const hours = Math.floor(diffInMilliseconds / 3600000);
      const minutes = Math.floor((diffInMilliseconds % 3600000) / 60000);
      this.timeDiff = `${hours} hours ${minutes} minutes`;
  }
  getAttendenceById(id){
    this.apiService.getAttendanceById(id).subscribe((res:any)=>{
      this.model.attendanceDate = res?.data?.attendanceDate
      this.model.startTime = res?.data?.startTime
      this.model.endTime = res?.data?.endTime
      this.timeDiff = res?.data?.workingHours
      this.model.workingHours = this.timeDiff
      this.model.task = res?.data?.task
      this.model.notes = res?.data?.notes
      this.model.admin_notes = res?.data?.admin_notes

      this.selected_verified = res?.data?.isVerified
      this.model.isVerified = this.selected_verified
      this.selected_emp = res?.data?.user?._id
      this.model.user = this.selected_emp
      this.selected_status = res?.data?.status
      this.model.status = this.selected_status

    })
  }
  getEmpId(event:any){
    this.selected_emp
  }
  getVerifiedId(event:any){
    this.selected_verified
  }
  getAllEmpList(){
    this.apiService.getEmployeeList(1,100).subscribe((res:any)=>{
      this.emp_list=res?.items
    })
  }
  getStatusList(){
    this.apiService.getTagByTagCatgoryId(this.employee_badge_cat_id).subscribe((res:any)=>{
      this.status_list=res.data
      this.status_list = res.data.filter(item =>
        ["full-day","on_leave", "short-leave", "half-day"].includes(item.name)
    );
    let status_idd = this.status_list.filter((item)=> ['full-day'].includes(item.name))
    this.selected_status = status_idd[0]?._id
    })
  }
  getStatusId(event){
    this.selected_status
  }

  get rf() {
    return this.attendenceForm.controls;
  }
  submit(){
    let attendenceDate = moment(this.attendenceForm.value.attendanceDate).format('DD-MM-YYYY')
    let body ={
      user : this.selected_emp?this.selected_emp: this.user_role.id,
      startTime: this.startTime.value,  
      endTime: this.endTime.value,
      workingHours : this.timeDiff,
      attendanceDate: attendenceDate,
      notes: this.attendenceForm.value.notes,
      isVerified: this.selected_verified,
      task: this.attendenceForm.value.task,
      status : this.selected_status
    }
    if(!this.attendence_id){
      this.apiService.addEmpAttendance(body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('Add Attendance Successfully')
            this.route.navigate(['/employees-attendence'])    
        }
        else{this.toastr.error(res.error)}
      })
        this.attendenceFormSubmitted = true;
      if (this.attendenceForm.invalid) {
        return;
      }
    }
    if(this.attendence_id){
      this.model.isVerified = this.selected_verified
      this.model.status = this.selected_status
      this.apiService.updateEmpAttendance(this.attendence_id,this.model).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('Add Attendance Successfully')
        // this.route.navigate(['/employees-attendence'])   
        window.history.back()   
        }
        else{this.toastr.error(res.error)}
      })
    }



  }
  
}
